import React from 'react'
interface InputFieldProps {
    type: string;
    placeholder?: string;
    value?: string | number ;
    onChange?: (e:any) => void;
    className: string;
    id?: string
    minLength?: any
    maxLength?: any
    register?: any;
    accept?: string;
    disabled?: boolean
    readOnly?: boolean
    role?: string
    defaultValue?: any
    onKeyDown?: any
    onInput?: any
}

const InputField = ({ type, placeholder, value, onChange, className, onInput, onKeyDown, id, minLength, maxLength, register, accept, disabled = false, readOnly = false, role, defaultValue }: InputFieldProps) => {
    const handleChange = (e: any) => {
        if (onChange) {
            onChange(e);  // Call the custom onChange handler
        }
        if (register && register.onChange) {
            register.onChange(e);  // Call the onChange from register
        }
    };

    return (
        <input
            type={type}
            placeholder={placeholder}
            defaultValue={defaultValue}
            value={value}
            onChange={handleChange}  // Use the combined handleChange function
            className={className}
            id={id}
            minLength={minLength}
            maxLength={maxLength}
            min={minLength}
            max={maxLength}
            accept={accept}
            disabled={disabled}
            readOnly={readOnly}
            role={role}
            onKeyDown={onKeyDown}
            onInput={onInput}
            {...(register ? { ref: register.ref, name: register.name } : {})}  // Destructure only necessary properties
        />
    );
};

// export default InputField;
export default InputField;